import { PageContainer } from "@/components/layout/PageContainer";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { ArrowRight, Stethoscope, Users } from "lucide-react";

const Solutions = () => {
  return (
    <PageContainer>
      <Helmet>
        <title>Healthcare AI Solutions - Scienza Health</title>
        <meta name="description" content="Comprehensive AI-powered healthcare solutions for clinical automation and workforce optimization." />
      </Helmet>
      
      <div className="min-h-screen py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
              Healthcare AI Solutions
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Transform healthcare delivery with our comprehensive suite of AI-powered solutions designed for clinical automation and workforce optimization.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {/* Clinical Automation */}
            <div className="bg-card border rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                <Stethoscope className="h-8 w-8 text-primary mr-3" />
                <h2 className="text-2xl font-semibold">Clinical Automation</h2>
              </div>
              <p className="text-muted-foreground mb-6">
                Streamline clinical workflows with AI-powered automation solutions that enhance patient care and operational efficiency.
              </p>
              <div className="space-y-3 mb-6">
                <Link to="/solutions/clinical-automation/virtual-nursing-observation" className="flex items-center justify-between p-3 border rounded hover:bg-muted/50 transition-colors">
                  <span>Virtual Nursing Observation</span>
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <Link to="/solutions/clinical-automation/cognitive-screening-intake" className="flex items-center justify-between p-3 border rounded hover:bg-muted/50 transition-colors">
                  <span>Cognitive Screening & Intake</span>
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <Link to="/solutions/clinical-automation/remote-patient-monitoring" className="flex items-center justify-between p-3 border rounded hover:bg-muted/50 transition-colors">
                  <span>Remote Patient Monitoring</span>
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <Link to="/solutions/clinical-automation/patient-access-automation" className="flex items-center justify-between p-3 border rounded hover:bg-muted/50 transition-colors">
                  <span>Patient Access Automation</span>
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
              <Link 
                to="/solutions/clinical-automation" 
                className="inline-flex items-center text-primary hover:text-primary/80 transition-colors"
              >
                Explore Clinical Automation <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </div>

            {/* Workforce & Customer Experience */}
            <div className="bg-card border rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                <Users className="h-8 w-8 text-primary mr-3" />
                <h2 className="text-2xl font-semibold">Workforce & Customer Experience</h2>
              </div>
              <p className="text-muted-foreground mb-6">
                Optimize your workforce and enhance customer experience with intelligent automation and AI-driven insights.
              </p>
              <div className="space-y-3 mb-6">
                <Link to="/solutions/workforce-customer-experience/workforce-optimization" className="flex items-center justify-between p-3 border rounded hover:bg-muted/50 transition-colors">
                  <span>Workforce Optimization</span>
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <Link to="/solutions/workforce-customer-experience/customer-experience" className="flex items-center justify-between p-3 border rounded hover:bg-muted/50 transition-colors">
                  <span>Customer Experience</span>
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
              <Link 
                to="/solutions/workforce-customer-experience" 
                className="inline-flex items-center text-primary hover:text-primary/80 transition-colors"
              >
                Explore Workforce Solutions <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default Solutions;